// src/theme/AppTheme.js
import { createTheme } from '@mui/material/styles';
// Giả sử bạn import các biến màu sắc từ Colors
import Colors from '../ckcore/core/Colors';

const DashboardTheme = createTheme({
  palette: {
    primary: {
      main: Colors.BG_BLUE,
    },
    secondary: {
      main: Colors.CK_VIOLET,
      contrastText: "#fff" //button text white instead of black
    },
    action: {
      main: "#FFFFFF",
    },
    gray: {
      main: Colors.GRAY
    },
    text: {
      // default text color if needed
    }
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '2px 6px',
        },
        sizeSmall: {
          padding: '2px 3px 2px 3px',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18,
        },
      },
    },
    // ...
  },
});

export default DashboardTheme;
